import React from 'react'
import { Link } from 'react-router-dom'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faBars } from '@fortawesome/free-solid-svg-icons';
import logo from '../Images/logo.png'
import './css/Nav_bar.css'

export default function Nav_bar() {
    return (
        <nav id="navbar" className="navbar fixed-top fixed-to navbar-expand-sm bg-white">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
          <img src={logo} alt="Case_studies_1" />
          </Link>
          {/* <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <FontAwesomeIcon icon={faBars} />
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto w-100 justify-content-end">
              <li className="nav-item active">
                <span data-toggle="collapse" data-target=".navbar-collapse.show" ><Link  className="nav-link" to="/">Home</Link></span>
              </li>
              <li className="nav-item">
                <span data-toggle="collapse " data-target=".navbar-collapse.show" ><Link  className="nav-link" to="/">About</Link></span>
              </li>
              <li className="nav-item">
                <span data-toggle="collapse " data-target=".navbar-collapse.show" ><Link  className="nav-link" to="/">Servicce</Link></span>
              </li>
              <li className="nav-item">
                <span data-toggle="collapse " data-target=".navbar-collapse.show" ><Link  className="nav-link" to="/">Contact</Link></span>
              </li>
            </ul>
          </div> */}
        </div>
      </nav>
    )
}
